import React, { useState } from 'react';
import { connect } from 'react-redux';

import { changeFilters, getNFList } from '../../../../redux/tracking';

import { nfFilters } from './enums';

import Regions from './Regions';
import Allowance from './Allowance';
import ContractedService from './ContractedService';
import Performance from './Performance';
import Status from './Status';
import Customers from './Customers';
import Scheduling from './Scheduling';
import Following from './Following';
import Invoice from './Invoice';
import Date from './Date';
import Subsidiaries from './Subsidiaries';
import SubsidiariesLuft from './SubsidiariesLuft';

import { Content, Overlay, Wrapper } from './styles';
import ShippingCompanies from './ShippingCompanies';

const NFFilters = ({ dispatch }) => {
  const [activeFilter, setActiveFilter] = useState(null);

  const _toggleFilter = filter => {
    setActiveFilter(activeFilter === filter ? null : filter);
  };

  // Date Filter
  const _applyDate = ({ byDate, initialDate, finalDate }) => {
    dispatch(
      changeFilters({
        byDate,
        initialPeriod: initialDate,
        finalPeriod: finalDate,
      }),
    );
    dispatch(getNFList());

    _toggleFilter(nfFilters.DATE);
  };

  // Region Filter
  const _applyRegionFilter = listRegion => {
    dispatch(changeFilters({ listRegion }));
    dispatch(getNFList());

    _toggleFilter(nfFilters.REGIONS);
  };

  // NF Type Filter
  const _applyNFTypeFilter = nfType => {
    dispatch(changeFilters({ nfType }));
    dispatch(getNFList());

    _toggleFilter(nfFilters.NF_TYPE);
  };

  // Abono Filter
  const _applyAllowanceFilter = listAllowance => {
    dispatch(changeFilters({ listAllowance }));
    dispatch(getNFList());

    _toggleFilter(nfFilters.ALLOWANCE);
  };

  // Contracted Service Filter
  const _applyContractedServiceFilter = listContractedService => {
    dispatch(changeFilters({ listContractedService }));
    dispatch(getNFList());

    _toggleFilter(nfFilters.CONTRACTEDSERVICE);
  };

  // Scheduled Filter
  const _applyScheduledFilter = scheduled => {
    dispatch(changeFilters({ scheduled }));
    dispatch(getNFList());

    _toggleFilter(nfFilters.SCHEDULING);
  };

  // Status Filter
  const _applyStatusFilter = listStatus => {
    dispatch(changeFilters({ listStatus }));
    dispatch(getNFList());

    _toggleFilter(nfFilters.STATUS);
  };

  // Performance Filter
  const _applyPerformanceFilter = listPerformance => {
    dispatch(changeFilters({ listPerformance }));
    dispatch(getNFList());

    _toggleFilter(nfFilters.PERFORMANCE);
  };

  // Customers Filter
  const _applyCustomersFilter = listCustomerTMS => {
    dispatch(changeFilters({ listCustomerTMS }));
    dispatch(getNFList());

    _toggleFilter(nfFilters.CUSTOMERS);
  };

  // Follow-up Filter
  const _applyFollowingedFilter = following => {
    dispatch(changeFilters({ following }));
    dispatch(getNFList());

    _toggleFilter(nfFilters.FOLLOWING);
  };

  // Subsidiaries Filter
  const _applySubsidiariesFilter = listCompany => {
    dispatch(changeFilters({ listCompany }));
    dispatch(getNFList());

    _toggleFilter(nfFilters.SUBSIDIARIES);
  };

  // Subsidiaries Luft Filter
  const _applySubsidiariesFilterLuft = listSubsidiaries => {
    dispatch(changeFilters({ listSubsidiaries }));
    dispatch(getNFList());

    _toggleFilter(nfFilters.SUBSIDIARIES_LUFT);
  };

  const _applyShippingCompanies = carrierCnpj => {
    dispatch(changeFilters({ carrierCnpj }));
    dispatch(getNFList());

    _toggleFilter(nfFilters.SHIPPING_COMPANIES);
  };

  return (
    <Wrapper>
      <Content>
        {activeFilter && (
          <Overlay onClick={() => _toggleFilter(activeFilter)} />
        )}
        <Date
          onClick={() => _toggleFilter(nfFilters.DATE)}
          isOpen={activeFilter === nfFilters.DATE}
          onApply={_applyDate}
        />

        <Regions
          onClick={() => _toggleFilter(nfFilters.REGIONS)}
          isOpen={activeFilter === nfFilters.REGIONS}
          onApply={_applyRegionFilter}
        />
        <Invoice
          onClick={() => _toggleFilter(nfFilters.NF_TYPE)}
          isOpen={activeFilter === nfFilters.NF_TYPE}
          onApply={_applyNFTypeFilter}
        />
        <Allowance
          onClick={() => _toggleFilter(nfFilters.ALLOWANCE)}
          isOpen={activeFilter === nfFilters.ALLOWANCE}
          onApply={_applyAllowanceFilter}
        />

        <ContractedService
          onClick={() => _toggleFilter(nfFilters.CONTRACTEDSERVICE)}
          isOpen={activeFilter === nfFilters.CONTRACTEDSERVICE}
          onApply={_applyContractedServiceFilter}
        />
        <Scheduling
          onClick={() => _toggleFilter(nfFilters.SCHEDULING)}
          isOpen={activeFilter === nfFilters.SCHEDULING}
          onApply={_applyScheduledFilter}
        />
        <Status
          onClick={() => _toggleFilter(nfFilters.STATUS)}
          isOpen={activeFilter === nfFilters.STATUS}
          onApply={_applyStatusFilter}
        />
        <Customers
          onClick={() => _toggleFilter(nfFilters.CUSTOMERS)}
          isOpen={activeFilter === nfFilters.CUSTOMERS}
          onApply={_applyCustomersFilter}
        />
        <Following
          onClick={() => _toggleFilter(nfFilters.FOLLOWING)}
          isOpen={activeFilter === nfFilters.FOLLOWING}
          onApply={_applyFollowingedFilter}
        />

        <Subsidiaries
          onClick={() => _toggleFilter(nfFilters.SUBSIDIARIES)}
          isOpen={activeFilter === nfFilters.SUBSIDIARIES}
          onApply={_applySubsidiariesFilter}
        />
        <SubsidiariesLuft
          onClick={() => _toggleFilter(nfFilters.SUBSIDIARIES_LUFT)}
          isOpen={activeFilter === nfFilters.SUBSIDIARIES_LUFT}
          onApply={_applySubsidiariesFilterLuft}
        />
        <Performance
          onClick={() => _toggleFilter(nfFilters.PERFORMANCE)}
          isOpen={activeFilter === nfFilters.PERFORMANCE}
          onApply={_applyPerformanceFilter}
        />
        <ShippingCompanies
          onClick={() => _toggleFilter(nfFilters.SHIPPING_COMPANIES)}
          isOpen={activeFilter === nfFilters.SHIPPING_COMPANIES}
          onApply={_applyShippingCompanies}
        />
      </Content>
    </Wrapper>
  );
};

// redux
export default connect()(NFFilters);
